import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import EnvironmentBanner from './components/EnvironmentBanner';
import reportWebVitals from './reportWebVitals';

// EnvironmentBanner is mounted here, beside the app rather than inside it, so the
// staging indicator is present on every screen — login included. It renders null
// unless REACT_APP_FIRESTORE_DB is set, so the member build is unchanged.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <EnvironmentBanner />
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
